import { render, staticRenderFns } from "./MessageGroups.vue?vue&type=template&id=140b8e1e&"
import script from "./MessageGroups.vue?vue&type=script&lang=js&"
export * from "./MessageGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports